import {
  SINGPASS_BUSINESS_INDUSTRY_MAP_FIELD,
  SINGPASS_BUSINESS_MAP_FIELD,
  SINGPASS_COMPANY_MAP_FIELD,
  SINGPASS_PERSONNEL_MAP_FIELD,
} from '@core/data-access';
import { FormGroup } from '@angular/forms';

export function disableBusinessIndustrySingpassFields(form: FormGroup) {
  disableFields(Object.keys(SINGPASS_BUSINESS_INDUSTRY_MAP_FIELD), form);
}

export function disableBusinessSingpassFields(form: FormGroup) {
  disableFields(Object.keys(SINGPASS_BUSINESS_MAP_FIELD), form);
}

export function disableCompanySingpassFields(form: FormGroup) {
  disableFields(Object.keys(SINGPASS_COMPANY_MAP_FIELD), form);
}

export function disableKeyPersonnelSingpassFields(form: FormGroup) {
  disableFields(Object.keys(SINGPASS_PERSONNEL_MAP_FIELD), form);
}

function disableFields(keys: string[], form: FormGroup) {
  keys.forEach(key => {
    form.get(key)?.disable({ emitEvent: false });
  });
}
